import { render, staticRenderFns } from "./SocialNetworksRefonte.vue?vue&type=template&id=6dec1989&scoped=true&"
import script from "./SocialNetworksRefonte.vue?vue&type=script&lang=js&"
export * from "./SocialNetworksRefonte.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworksRefonte.vue?vue&type=style&index=0&id=6dec1989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec1989",
  null
  
)

export default component.exports